import { call } from 'redux-saga/effects'
import { NearpodError } from 'redux/sagas/helpers/error_formatter'

function *callAny(...args) {
	let response, serverError
	try {
		response = yield call.apply(null, args)
	} catch (err) {
		serverError = err

	}

	if (response && 'errorCode' in response) {
		response.error_code = response.errorCode
	}

	//In case there is an unhandled error
	if (!response && (!serverError || !serverError.error_code)) {
		serverError = {error_code: -1}
	}

	//Only for old API that returns errors as a resolve
	if (response && 'error_code' in response && response.error_code !== 0) {
		const {error_code, message, payload, ...extraProps} = response
		const payloadWithProps = payload || extraProps
		serverError = {
			...response,
			...(Object.keys(payloadWithProps).length && {payload: payloadWithProps}),
		}
	}

	if (serverError) {
		throw new NearpodError(serverError.error_code, serverError.message, serverError.payload)
	}

	return response
}

function *callAnyWithCode(...args) {
	let response, serverError
	try {
		response = yield call.apply(null, args)
	} catch (err) {
		serverError = err

	}

	if (response
			&& typeof response === 'object'
			&& 'errorCode' in response) {
		response.error_code = response.errorCode
	}

	if (serverError && serverError.statusCode) {
		serverError = {
			error_code: serverError.statusCode,
			message: serverError.message,
		}
	}

	//In case there is an unhandled error
	if (!response && (!serverError || !serverError.error_code)) {
		serverError = {error_code: -1}
	}

	//Only for old API that returns errors as a resolve
	if (response
			&& typeof response === 'object'
			&& 'error_code' in response
			&& response.error_code !== 0) {
		const {error_code, message, payload, ...extraProps} = response
		const payloadWithProps = payload || extraProps
		serverError = {
			...response,
			...(Object.keys(payloadWithProps).length && {payload: payloadWithProps}),
		}
	}

	if (serverError) {
		throw new NearpodError(serverError.error_code, serverError.message, serverError.payload)
	}

	return response
}

export default callAny

export {
	callAnyWithCode,
}
